/* prettier-ignore */

import { inject, Injectable } from '@angular/core';
import { CookieService } from "ngx-cookie-service";
import { TranslateService } from "@ngx-translate/core";
import { RestService } from './rest.service';

enum LocaleCode {
  ES_ES = 'es-ES',
  EN_GB = 'en-GB',
  FR_FR = 'fr-FR',
  IT_IT = 'it-IT',
  DE_DE = 'de-DE',
  CH_CH = 'ch-CH',
  CA_ES = 'ca-ES',
  NL_NL = 'nl-NL',
  GL_ES = 'gl-ES',
  VA_ES = 'ca-ES-valencia',
  PT_PT = 'pt-PT',
  EU_ES = 'eu-ES',
  RU_RU = 'ru-RU',
  JA_JP = 'ja-JP',
  KO_KR = 'ko-KR',
}

@Injectable({providedIn: 'root'})

export class GoogleTranslateService {
    private rest = inject(RestService);
    public translateService: TranslateService = inject(TranslateService);
    private cookieService: CookieService = inject(CookieService);
    public currentLang: any = this.getCookieLang() || this.rest.device?.mainLanguage || 'es';
    private mainLang = this.rest.device?.mainLanguage || 'es';
    public langFromCurrentRoute: boolean = false;

    public availableLangs = [
      { name: "Albanés", code: "sq" },
      { name: "Amárico", code: "am" },
      { name: "Árabe", code: "ar" },
      { name: "Armenio", code: "hy" },
      { name: "Azerbaiyano", code: "az" },
      { name: "Vasco", code: "eu" },
      { name: "Bielorruso", code: "be" },
      { name: "Bengalí", code: "bn" },
      { name: "Bosnio", code: "bs" },
      { name: "Búlgaro", code: "bg" },
      { name: "Catalán", code: "ca" },
      { name: "Chino (Simplificado)", code: "zh-CN" },
      { name: "Chino (Tradicional)", code: "zh-TW" },
      { name: "Corso", code: "co" },
      { name: "Croata", code: "hr" },
      { name: "Checo", code: "cs" },
      { name: "Danés", code: "da" },
      { name: "Español", code: "es" },
      { name: "Neerlandés", code: "nl" },
      { name: "Inglés", code: "en" },
      { name: "Estonio", code: "et" },
      { name: "Finlandés", code: "fi" },
      { name: "Francés", code: "fr" },
      { name: "Gallego", code: "gl" },
      { name: "Alemán", code: "de" },
      { name: "Griego", code: "el" },
      { name: "Gujarati", code: "gu" },
      { name: "Criollo Haitiano", code: "ht" },
      { name: "Húngaro", code: "hu" },
      { name: "Islandés", code: "is" },
      { name: "Indonesio", code: "id" },
      { name: "Irlandés", code: "ga" },
      { name: "Italiano", code: "it" },
      { name: "Japonés", code: "ja" },
      { name: "Canarés", code: "kn" },
      { name: "Khmer", code: "km" },
      { name: "Kinyarwanda", code: "rw" },
      { name: "Coreano", code: "ko" },
      { name: "Kirguís", code: "ky" },
      { name: "Latín", code: "la" },
      { name: "Letón", code: "lv" },
      { name: "Lituano", code: "lt" },
      { name: "Luxemburgués", code: "lb" },
      { name: "Macedonio", code: "mk" },
      { name: "Malgache", code: "mg" },
      { name: "Malayo", code: "ms" },
      { name: "Malayalam", code: "ml" },
      { name: "Maltés", code: "mt" },
      { name: "Maratí", code: "mr" },
      { name: "Mongol", code: "mn" },
      { name: "Myanmar (Birmano)", code: "my" },
      { name: "Nepalí", code: "ne" },
      { name: "Noruego", code: "no" },
      { name: "Pastún", code: "ps" },
      { name: "Polaco", code: "pl" },
      { name: "Portugués", code: "pt" },
      { name: "Panyabí", code: "pa" },
      { name: "Rumano", code: "ro" },
      { name: "Ruso", code: "ru" },
      { name: "Samoano", code: "sm" },
      { name: "Gaélico Escocés", code: "gd" },
      { name: "Serbio", code: "sr" },
      { name: "Sesotho", code: "st" },
      { name: "Shona", code: "sn" },
      { name: "Sindhi", code: "sd" },
      { name: "Cingalés", code: "si" },
      { name: "Eslovaco", code: "sk" },
      { name: "Esloveno", code: "sl" },
      { name: "Somalí", code: "so" },
      { name: "Sueco", code: "sv" },
      { name: "Tagalo (Filipino)", code: "tl" },
      { name: "Tayiko", code: "tg" },
      { name: "Tártaro", code: "tt" },
      { name: "Tailandés", code: "th" },
      { name: "Turco", code: "tr" },
      { name: "Turkmeno", code: "tk" },
      { name: "Ucraniano", code: "uk" },
      { name: "Uigur", code: "ug" },
      { name: "Uzbeko", code: "uz" },
      { name: "Vietnamita", code: "vi" },
      { name: "Galés", code: "cy" }
  ];
    
    constructor(){}

    getCookieLang(){
      const cookie =  this.cookieService.get('googtrans')
      if (!cookie) return null;
      const cookieSplit = cookie.split('/');
      return cookieSplit?.[cookieSplit.length - 1];
    }

    deleteCookieLang(){
      this.cookieService.delete('googtrans', '/', `${this.rest.subDomain}.localhost`);
      this.cookieService.delete('googtrans', '/', `.${this.rest.subDomain}.localhost`);
      this.cookieService.delete('googtrans', '/', `${this.rest.subDomain}.ciceroneweb.com`);
      this.cookieService.delete('googtrans', '/', `.${this.rest.subDomain}.ciceroneweb.com`);
      this.cookieService.delete('googtrans', '/', '.ciceroneweb.com');
      this.cookieService.deleteAll('/');
      document.cookie = "googtrans=; path=/; domain=.localhost; expires=Thu, 01 Jan 1970 00:00:00 UTC";
      document.cookie = `googtrans=; path=/; domain=${this.rest.subDomain}.localhost; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
      document.cookie = "googtrans=; path=/; domain=.ciceroneweb.com; expires=Thu, 01 Jan 1970 00:00:00 UTC";
      document.cookie = `googtrans=; path=/; domain=${this.rest.subDomain}.ciceroneweb.com; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
      location.reload(); 
    }

    setLang(lang: string){
      this.setCookieLang(lang);
      this.setLocalLang(lang);
      location.reload();
    }

    setCookieLang(lang){
      this.cookieService.delete('googtrans', '/', `${this.rest.subDomain}.localhost`);
      this.cookieService.delete('googtrans', '/', `.${this.rest.subDomain}.localhost`);
      this.cookieService.delete('googtrans', '/', `${this.rest.subDomain}.ciceroneweb.com`);
      this.cookieService.delete('googtrans', '/', `.${this.rest.subDomain}.ciceroneweb.com`);
      this.cookieService.delete('googtrans', '/', '.ciceroneweb.com');
      this.cookieService.deleteAll('/');

      console.log("setting lang from cookie");
      document.cookie = `googtrans=/${this.mainLang}/${lang}; path=/; domain=.localhost; expires=Thu, 01 Jan 2030 00:00:00 UTC`;
      document.cookie = `googtrans=/${this.mainLang}/${lang}; path=/; domain=${this.rest.subDomain}.localhost; expires=Thu, 01 Jan 2030 00:00:00 UTC`;

      document.cookie = `googtrans=/${this.mainLang}/${lang}; path=/; domain=.ciceroneweb.com; expires=Thu, 01 Jan 2030 00:00:00 UTC`;
      document.cookie = `googtrans=/${this.mainLang}/${lang}; path=/; domain=${this.rest.subDomain}.ciceroneweb.com; expires=Thu, 01 Jan 2030 00:00:00 UTC`;
      console.log("Setting lang from cookie: ", lang);
    }

    setRandomLang(){
      const langs = this.availableLangs.map(lang => lang.code);
      const randomLang = langs[Math.floor(Math.random() * langs.length)];
      this.setLang(randomLang)
    }

    setLocalLang(lang: string){
      this.cookieService.delete('locallang');
      // this.cookieService.set('locallang', lang);
      this.cookieService.set(
        'locallang',
        lang,
        undefined, // expires
        '/',       // path
        undefined, // domain
        true,      // secure
        'Lax',     // sameSite
        false      // partitioned
      );
    }

    getLocalLang(){
      const cookie = this.cookieService.get('locallang')
      if (!cookie || cookie === '') return null
      return cookie;
    }

    removeLocalLang(){
      this.cookieService.delete('locallang');
    }

    changeLanguage(lang) {
      this.currentLang = lang
      this.translateService.setDefaultLang(lang);
      this.translateService.use(lang);
      this.setLocalLang(lang);
    }

    changeLangOnInit(lang, apiLangs = ['es', 'en']){
      if (!lang)
        return;

      const currentCookieLang = this.getCookieLang();
      if (apiLangs?.includes(lang)){
        if (currentCookieLang)
          this.deleteCookieLang();

        this.changeLanguage(lang);
        return;
      }

      if (currentCookieLang === lang)
        return;

      const foundLang = this.availableLangs?.find(e => e.code === lang);
      if (!foundLang)
        return;

      this.setLang(lang);
    }
    
    cookieLangMapping(lang: string) {
      switch (lang) {
        case 'es':
          return LocaleCode.ES_ES
        case 'en':
          return LocaleCode.EN_GB
        case 'fr':
          return LocaleCode.FR_FR
        case 'it':
          return LocaleCode.IT_IT
        case 'de':
          return LocaleCode.DE_DE
        case 'ch':
          return LocaleCode.CH_CH
        case 'ca':
          return LocaleCode.CA_ES
        case 'nl':
          return LocaleCode.NL_NL
        case 'gl':
          return LocaleCode.GL_ES
        case 'va':
          return LocaleCode.VA_ES
        case 'pt':
          return LocaleCode.PT_PT
        case 'eu':
          return LocaleCode.EU_ES
        case 'ru':
          return LocaleCode.RU_RU
        case 'ja':
          return LocaleCode.JA_JP
        case 'ko':
          return LocaleCode.KO_KR
        default:
          return LocaleCode.ES_ES
      }
    }
}

